module.exports = __webpack_public_path__ + "img/ic-contact-line_my.9f8e833d.png";